import { FC, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import VaultItem from '@components/vault-all/vault-item';
import { useVaultsMine } from '@hooks/use-vaults-mine';
import { useAddress } from '@hooks/use-address';
import Button from '@ui/button';
import { walletConnectModel } from '@models/wallet-connect.model';
import styles from './index.module.scss';
import { type MyVaultsStruct } from '@models/myvault.model';
import { type ProtocolListType } from '@constants/protocol-list';

interface OwnProps {
  myVaults?: MyVaultsStruct[];
}
const MyVault: FC<OwnProps> = ({ myVaults }) => {
  const address = useAddress();
  const [sortType, setSortType] =
    useState<OpenapiClientParrotVault.GetVaultVaultsQuery['direction']>('desc');
  const [sortValue, setSortValue] =
    useState<OpenapiClientParrotVault.GetVaultVaultsQuery['sort']>('liquidity_usd');
  const [protocolValue, setProtocolValue] = useState<ProtocolListType>('all');

  const { vaultsMine } = useVaultsMine({
    direction: sortType,
    sort: sortValue,
    protocol: protocolValue === 'all' ? undefined : protocolValue,
  });

  const handleSort = (value: OpenapiClientParrotVault.GetVaultVaultsQuery['sort']) => {
    if (sortValue === value) {
      setSortType(sortType === 'desc' ? 'asc' : 'desc');
    } else {
      setSortType('desc');
    }
    setSortValue(value);
  };

  return (
    <>
      {!address ? (
        <div className={styles.connect}>
          <Button onClick={walletConnectModel.toggleDialog}>Connect Wallet</Button>
        </div>
      ) : (
        <VaultItem
          vaults={vaultsMine}
          handleSort={handleSort}
          sortType={sortType}
          sortValue={sortValue}
          protocolValue={protocolValue}
          onChangeProtocolValue={setProtocolValue}
          myVaults={myVaults}
        />
      )}
    </>
  );
};

export default MyVault;
